
<template>
  <!-- Menu Page Start -->
  <section class="menu_page_area">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="menu_page_inn">
            <div class="menu_nav">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li
                  role="presentation"
                  v-for="(tab, key) in tabs"
                  :key="key"
                >
                  <a
                    href="javascript:;"
                    :class="{ active: tab.isActive }"
                    data-bs-toggle="tab"
                    data-bs-target="#all"
                    role="tab"
                    aria-controls="all"
                    aria-selected="true"
                    @click.stop.prevent="setActive(tab)"
                  >
                    {{ tab.title }}
                  </a>
                </li>
              </ul>
            </div>

            <div class="tab-content" id="myTabContent">
              <div
                :class="{
                  'tab-pane': true,
                  fade: true,
                  show: tab.isActive,
                  active: tab.isActive
                }"
                v-for="(tab, key) in tabs"
                :key="key"
                role="tabpanel"
              >
                <div class="row">
                  <div class="col-md-11 mx-auto">
                    <div class="food_menu_inn">
                      <div class="row justify-content-between">
                        <div
                          class="col-lg-6 col-sm-12"
                          v-for="(item, key) in getContents(tab)"
                          :key="key"
                        >
                          <div class="menu_page_table">
                            <div class="food_menu_item">
                              <div class="menu-item_content-wrap">
                                <div class="menu-item_content">
                                  <div class="menu-item_title">
                                    <h4>{{ item.title }}</h4>
                                  </div>
                                </div>

                                <div class="menu-item_desc">
                                  <p>{{ item.description }}</p>
                                </div>

                                <div class="menu-item_price" v-if="item.personal || item.mediana">
                                  <h5 v-if="item.personal">Personal: {{ item.currency }}{{ item.personal }}</h5>
                                  <h5 v-if="item.mediana">Mediana: {{ item.currency }}{{ item.mediana }}</h5>
                                </div>

                                <div class="menu-item_price" v-else>
                                  <h4>{{ item.size ? item.size + ' - ' : '' }}{{ item.currency }}{{ item.price }}</h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Menu Page End -->
</template>

<script>
export default {
  name: "MenuPageArea",
  data() {
    return {
      activatedTab: {},
      tabs: [
        {
          title: "Todos",
          category: "all-tab",
          isActive: true,
        },
        {
          title: "Clásicas",
          category: "clasicas",
          isActive: false,
        },
        {
          title: "Especiales",
          category: "especiales",
          isActive: false,
        },
        {
          title: "Botanas",
          category: "botanas",
          isActive: false,
        },
      ],
      tabContent: [
        {
          category: "clasicas",
          title: "Pizza Pepperoni",
          description: "Solo pepperoni",
          currency: "$",
          personal: 150,
          mediana: 250,
        },
        {
          category: "clasicas",
          title: "Pizza Spicy Pepperoni",
          description: "Pepperoni y Jalapeño verde",
          currency: "$",
          personal: 160,
          mediana: 260,
        },
        {
          category: "clasicas",
          title: "Pizza de Carnes",
          description: "Pepperoni, Tocino y Jamón",
          currency: "$",
          personal: 180,
          mediana: 280,
        },
        {
          category: "clasicas",
          title: "Pizza de Quesos",
          description: "Parmesano y Mozarella",
          currency: "$",
          personal: 140,
          mediana: 240,
        },
        {
          category: "especiales",
          title: "Pizza Campestre",
          description: "Jamón, Chile Morrón y Cebolla",
          currency: "$",
          personal: 170,
          mediana: 270,
        },
        {
          category: "especiales",
          title: "Pizza de Vegetales",
          description: "Jalapeño y Champiñones",
          currency: "$",
          personal: 150,
          mediana: 250,
        },
        {
          category: "botanas",
          title: "Sampler",
          description: "Dedos de queso 100g, Papas fritas 100g y Aros de cebolla 100g",
          currency: "$",
          price: 180,
        },
        {
          category: "botanas",
          title: "Papas Fritas",
          description: "300g",
          currency: "$",
          price: 100,
        },
      ],
    };
  },
  methods: {
    getContents(tab) {
      const category = tab.category;

      if (category === "all-tab") {
        return this.tabContent;
      }

      return this.tabContent.filter((item) => item.category === category);
    },
    setActive(tab) {
      this.tabs.forEach((item) => {
        item.isActive = item.category === tab.category;
      });
      this.activatedTab = tab;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/MenuPageArea.vue